import FRApi from './_frApi';

class ManagementLayoutReportAPI extends FRApi {
  constructor() {
    super();
  }
  controllerName = 'ManagementLayoutReports';
}

export default new ManagementLayoutReportAPI();
